quosal.api.arrowQuote = {};

quosal.api.arrowQuote.searchQuotes = function (fromDate, toDate) {
    return quosal.api.call('Arrow.QuoteSearch', {
        fromDate: fromDate,
        toDate: toDate
    });
};

quosal.api.arrowQuote.previewQuote = function (quoteNumber) {
    return quosal.api.call('Arrow.QuotePreview', {
        quoteNumber: quoteNumber
    });
};

quosal.api.arrowQuote.importQuote = function (arrowQuoteNumber, idQuoteMain, idQuoteTabs, selectedItems, useArrowExpirationDate, arrowExpirationDate) {
    return quosal.api.call('Arrow.QuoteImport', {
        arrowQuoteNumber: arrowQuoteNumber,
        idQuoteMain: idQuoteMain,
        idQuoteTabs: idQuoteTabs,
        selectedItems: selectedItems,
        useArrowExpirationDate: useArrowExpirationDate,
        arrowExpirationDate: arrowExpirationDate
    });
};

quosal.api.arrowQuote.importTerm = function (hardwareTotal, softwareTotal, enterPoints, blindDiscount, offerOptions) {
    return quosal.api.call('Arrow.TermImport', {
        hardwareTotal: hardwareTotal,
        softwareTotal: softwareTotal,
        enterPoints: enterPoints,
        blindDiscount: blindDiscount,
        offerOptions: offerOptions
    });
};